import axios, { AxiosRequestConfig } from 'axios';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getSessionCredentials, clearSessionCredentials } from '../globalFunctions';

export const useSchool = () => {
    const token = getSessionCredentials()?.token ?? '';
    const navigate = useNavigate();

    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
        }
    };

    return useQuery({
        queryKey: ['schools'],
        queryFn: async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/schools`,
                    requestConfig
                );

                return response.data;
            } catch (error: any) {
                const response = {
                    message: 'Erro ao carregar instituições',
                    error: error
                };

                if ([401, 419].includes(error.response.status)) {
                    // Unauthorized
                    clearSessionCredentials(navigate);
                } else {
                    console.error(response);
                    return response;
                }
            }
        }
    });
};
